module.exports = __webpack_public_path__ + "img/kz.09c40dc4.svg";